module.exports = __webpack_public_path__ + "static/img/his-Asset 78.4f95d12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/his-Asset 78.png
// module id = 5XPF
// module chunks = 2